/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseListItemViewModelPaginatedResponse } from "../types/CourseListItemViewModelPaginatedResponse.ts";
import { courseListItemViewModelSchema } from "./courseListItemViewModelSchema.ts";

export const courseListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => courseListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CourseListItemViewModelPaginatedResponse>;
